import Chip from "@mui/material/Chip"

import Row from "../../../common/components/Row"
import { REPORT_STATUS } from "./activityReportRowUtils"

const FILTER_OPTIONS = [
  { id: REPORT_STATUS.all, label: "All" },
  { id: REPORT_STATUS.pending, label: "Pending" },
  { id: REPORT_STATUS.sent, label: "Sent" },
  { id: REPORT_STATUS.failed, label: "Failed" },
]

function countForFilter(filterId, analytics) {
  if (!analytics) {
    return null
  }
  switch (filterId) {
    case REPORT_STATUS.pending:
      return analytics.reports_pending
    case REPORT_STATUS.sent:
      return analytics.reports_sent
    case REPORT_STATUS.failed:
      return analytics.reports_failed
    default:
      return null
  }
}

export default function ActivityReportStatusFilter({
  value,
  onChange,
  analytics,
  loading = false,
}) {
  return (
    <Row gap={1} sx={{ flexWrap: "wrap" }}>
      {FILTER_OPTIONS.map((option) => {
        const count = countForFilter(option.id, analytics)
        const selected = value === option.id
        return (
          <Chip
            key={option.id}
            label={`${option.label}${
              loading || count === null ? "" : ` (${count})`
            }`}
            clickable
            color={selected ? "primary" : "default"}
            variant={selected ? "filled" : "outlined"}
            onClick={() => onChange(option.id)}
          />
        )
      })}
    </Row>
  )
}
